import type { DataProvider } from 'ra-core'
import { getCurrentDate } from 'util/date'
import type { UtilityTariffDefaultCountry, UtilityTariffDefaultValueFunc } from './utilityTariffTypes'

const UTILITY_TARIFF_COPY_STRIP_KEYS = [
  'id',
  'url',
  'created_date',
  'modified_date',
  'created_by_role_email',
  'modified_by_role_email',
  'modified_is_public_read_only_by_role_email',
  'modified_is_public_read_only_date',
  'distributor_name',
  'country_iso2',
  'recently_used',
  'org_id',
  'transition_to_utility_tariff_code',
  'org',
  'is_public_read_only',
  'utility_tariff_group',
  'valid_from',
  'valid_to',
] as const

const LIST_FILTERS_FOR_LATEST_ROW = [{ is_latest: true }, {}] as const

function listParamsForCatalogueGroup(catalogueGroupUrl: string, extraFilter: Record<string, unknown> = {}) {
  return {
    filter: { utility_tariff_group: catalogueGroupUrl, ...extraFilter },
    sort: { field: 'valid_from', order: 'DESC' as const },
    pagination: { page: 1, perPage: 1 },
  }
}

export async function fetchLatestUtilityTariffForGroup(
  dataProvider: DataProvider,
  catalogueGroupUrl: string
): Promise<Record<string, unknown> | null> {
  for (const extraFilter of LIST_FILTERS_FOR_LATEST_ROW) {
    const { data } = await dataProvider.getList(
      'utility_tariffs',
      listParamsForCatalogueGroup(catalogueGroupUrl, extraFilter)
    )
    const id = (data?.[0] as { id?: number | string } | undefined)?.id
    if (id != null) {
      const { data: full } = await dataProvider.getOne('utility_tariffs', { id })
      return full as Record<string, unknown>
    }
  }
  return null
}

export function valuesForCreateFromCopiedUtilityRow(
  apiRecord: Record<string, unknown>,
  defaultCountry: UtilityTariffDefaultCountry,
  catalogueGroupUrl: string,
  defaultValueFunc: UtilityTariffDefaultValueFunc
): Record<string, unknown> {
  const merged = defaultValueFunc(apiRecord, null, defaultCountry, catalogueGroupUrl)
  const out = { ...merged }
  for (const key of UTILITY_TARIFF_COPY_STRIP_KEYS) {
    delete out[key]
  }
  return {
    ...out,
    is_latest: false,
    valid_from: getCurrentDate(),
    valid_to: null,
  }
}
